import { useEffect, useState } from "react";
import { Who5Create } from "./Who5Create";
import { useLoaderData, useParams } from "react-router-dom";

import * as APIUSER from "../services/user";

export function Who5New(props) {
  const who5 = useLoaderData();

  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  const [who5Resp, setWho5Resp] = useState(props.especialistaFullName);
  const [metaFecha, setWho5Fecha] = useState(todayDate);
  const [who5Alegre, setWho5Alegre] = useState("");
  const [who5Tranquilo, setWho5Tranquilo] = useState("");
  const [who5Activo, setWho5Activo] = useState("");
  const [who5Despejado, setWho5Despejado] = useState("");
  const [who5Interesan, setWho5Interesan] = useState("");

  // Sum of all WHO-5 test responses
  const totalSumWho5 =
    4 *
    ((parseInt(who5Alegre) || 0) +
      (parseInt(who5Tranquilo) || 0) +
      (parseInt(who5Activo) || 0) +
      (parseInt(who5Despejado) || 0) +
      (parseInt(who5Interesan) || 0));

  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();

  const submitWho5 = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setIsErrorModalOpen(false);
    setIsCreatingButton(true);

    console.log(
      who5Resp,
      metaFecha,
      who5Alegre,
      who5Tranquilo,
      who5Activo,
      who5Despejado,
      who5Interesan,
      tratamientoId,
      pacienteId
    );
    try {
      // Crear un objeto que mapea cada pregunta con su valor actual
      const who5Answers = [
        who5Alegre,
        who5Tranquilo,
        who5Activo,
        who5Despejado,
        who5Interesan,
      ];
      
      // Luego cuenta cuántas están respondidas
      const answeredQuestions = who5Answers.filter((val) => val !== "").length;
      const totalQuestions = who5Answers.length;
      const percentage = (answeredQuestions / totalQuestions) * 100;
      
      if (percentage < 100) {
        setErrorMessage(
          "Para que podamos trabajar en tu recuperación y bienestar, necesitamos tus respuestas."
        );
        setIsErrorModalOpen(true);
        setIsCreatingButton(false);
        return;
      }

      await Who5Create(
        who5Resp,
        metaFecha,
        who5Alegre,
        who5Tranquilo,
        who5Activo,
        who5Despejado,
        who5Interesan,
        tratamientoId,
        pacienteId
      ).then(
        (val) => {
          window.location.replace(`../who5/${val.id}`);
          // console.log(val);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
      {/* Modal de Error */}
      {isErrorModalOpen && (
          <div className={`modal ${isErrorModalOpen ? "is-active" : ""}`}>
            <div
              className="modal-background"
              onClick={() => setIsErrorModalOpen(false)}
            ></div>
            <div className="modal-card">
              <header className="modal-card-head">
                <p className="modal-card-title">Algo salió mal...</p>
                <button
                  className="delete"
                  aria-label="close"
                  onClick={() => setIsErrorModalOpen(false)}
                ></button>
              </header>
              <section className="modal-card-body">{errorMessage}</section>
              <footer className="modal-card-foot">
                <button
                  className="button is-danger"
                  onClick={() => setIsErrorModalOpen(false)}
                >
                  Cerrar
                </button>
              </footer>
            </div>
          </div>
        )}
        <form
          id='formNewElement'
          className='newRadioButtons'
          onSubmit={submitWho5}
        >
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='who5Resp'>Responsable</label>
              <div className='control'>
                <input
                  className='input'
                  id='who5Resp'
                  required
                  type='text'
                  value={who5Resp}
                  onChange={(e) => setWho5Resp(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='metaFecha'>Fecha visita</label>
              <div className='control'>
                <input
                  className='input'
                  id='metaFecha'
                  required
                  type='date'
                  value={metaFecha}
                  onChange={(e) => setWho5Fecha(e.target.value)}
                />
              </div>
            </div>
          </div>
          <h3>Cuestionario WHO-5</h3>
          <p>Ayúdanos a optimizar tu tratamiento y observa tu evolución. Completa el cuestionario y OBTÉN 5€ A CAMBIO.</p>
              <br></br>
              <p>Por favor, indica para cada una de las 5 afirmaciones cuál es la que mejor refleja CÓMO TE HAS SENTIDO DURANTE LOS ÚLTIMOS 30 DÍAS.</p>
              <br></br>
          <div className='form-radio-container'>
            <p>Durante las 2 últimas semanas…</p>
            <div className='grid--2-col'>
              <div className='radio-capt radio--6-col'>
                <p>Todo el tiempo</p>
                <p>La mayor parte del tiempo</p>
                <p>Más de la mitad del tiempo</p>
                <p>Menos de la mitad del tiempo</p>
                <p>Algo del tiempo</p>
                <p>En ningún momento</p>
              </div>
            </div>
            <div className='field'>
              <div className='control grid--2col'>
                <label className='radio-title' htmlFor='who5Alegre'>
                  1. me he sentido alegre y con buen ánimo
                </label>
                <div className='radio--6-col'>
                  <label className='radio' htmlFor='who5Alegre-5'>
                    <input
                      id='who5Alegre-5'
                      name='who5Alegre'
                      type='radio'
                      value='5'
                      checked={who5Alegre === "5"}
                      onChange={(e) => setWho5Alegre(e.target.value)}
                    />
                    5
                  </label>
                  <label className='radio' htmlFor='who5Alegre-4'>
                    <input
                      id='who5Alegre-4'
                      name='who5Alegre'
                      type='radio'
                      value='4'
                      checked={who5Alegre === "4"}
                      onChange={(e) => setWho5Alegre(e.target.value)}
                    />
                    4
                  </label>
                  <label className='radio' htmlFor='who5Alegre-3'>
                    <input
                      id='who5Alegre-3'
                      name='who5Alegre'
                      type='radio'
                      value='3'
                      checked={who5Alegre === "3"}
                      onChange={(e) => setWho5Alegre(e.target.value)}
                    />
                    3
                  </label>
                  <label className='radio' htmlFor='who5Alegre-2'>
                    <input
                      id='who5Alegre-2'
                      name='who5Alegre'
                      type='radio'
                      value='2'
                      checked={who5Alegre === "2"}
                      onChange={(e) => setWho5Alegre(e.target.value)}
                    />
                    2
                  </label>
                  <label className='radio' htmlFor='who5Alegre-1'>
                    <input
                      id='who5Alegre-1'
                      name='who5Alegre'
                      type='radio'
                      value='1'
                      checked={who5Alegre === "1"}
                      onChange={(e) => setWho5Alegre(e.target.value)}
                    />
                    1
                  </label>
                  <label className='radio' htmlFor='who5Alegre-0'>
                    <input
                      id='who5Alegre-0'
                      name='who5Alegre'
                      type='radio'
                      value='0'
                      checked={who5Alegre === "0"}
                      onChange={(e) => setWho5Alegre(e.target.value)}
                    />
                    0
                  </label>
                </div>
              </div>
            </div>
            <div className='field'>
              <div className='control grid--2col'>
                <label className='radio-title' htmlFor='who5Tranquilo'>
                  2. me he sentido tranquilo y relajado
                </label>
                <div className='radio--6-col'>
                  <label className='radio' htmlFor='who5Tranquilo-5'>
                    <input
                      id='who5Tranquilo-5'
                      name='who5Tranquilo'
                      type='radio'
                      value='5'
                      checked={who5Tranquilo === "5"}
                      onChange={(e) => setWho5Tranquilo(e.target.value)}
                    />
                    5
                  </label>
                  <label className='radio' htmlFor='who5Tranquilo-4'>
                    <input
                      id='who5Tranquilo-4'
                      name='who5Tranquilo'
                      type='radio'
                      value='4'
                      checked={who5Tranquilo === "4"}
                      onChange={(e) => setWho5Tranquilo(e.target.value)}
                    />
                    4
                  </label>
                  <label className='radio' htmlFor='who5Tranquilo-3'>
                    <input
                      id='who5Tranquilo-3'
                      name='who5Tranquilo'
                      type='radio'
                      value='3'
                      checked={who5Tranquilo === "3"}
                      onChange={(e) => setWho5Tranquilo(e.target.value)}
                    />
                    3
                  </label>
                  <label className='radio' htmlFor='who5Tranquilo-2'>
                    <input
                      id='who5Tranquilo-2'
                      name='who5Tranquilo'
                      type='radio'
                      value='2'
                      checked={who5Tranquilo === "2"}
                      onChange={(e) => setWho5Tranquilo(e.target.value)}
                    />
                    2
                  </label>
                  <label className='radio' htmlFor='who5Tranquilo-1'>
                    <input
                      id='who5Tranquilo-1'
                      name='who5Tranquilo'
                      type='radio'
                      value='1'
                      checked={who5Tranquilo === "1"}
                      onChange={(e) => setWho5Tranquilo(e.target.value)}
                    />
                    1
                  </label>
                  <label className='radio' htmlFor='who5Tranquilo-0'>
                    <input
                      id='who5Tranquilo-0'
                      name='who5Tranquilo'
                      type='radio'
                      value='0'
                      checked={who5Tranquilo === "0"}
                      onChange={(e) => setWho5Tranquilo(e.target.value)}
                    />
                    0
                  </label>
                </div>
              </div>
            </div>
            <div className='field'>
              <div className='control grid--2col'>
                <label className='radio-title' htmlFor='who5Activo'>
                  3. me he sentido activo y con energía
                </label>
                <div className='radio--6-col'>
                  <label className='radio' htmlFor='who5Activo-5'>
                    <input
                      id='who5Activo-5'
                      name='who5Activo'
                      type='radio'
                      value='5'
                      checked={who5Activo === "5"}
                      onChange={(e) => setWho5Activo(e.target.value)}
                    />
                    5
                  </label>
                  <label className='radio' htmlFor='who5Activo-4'>
                    <input
                      id='who5Activo-4'
                      name='who5Activo'
                      type='radio'
                      value='4'
                      checked={who5Activo === "4"}
                      onChange={(e) => setWho5Activo(e.target.value)}
                    />
                    4
                  </label>
                  <label className='radio' htmlFor='who5Activo-3'>
                    <input
                      id='who5Activo-3'
                      name='who5Activo'
                      type='radio'
                      value='3'
                      checked={who5Activo === "3"}
                      onChange={(e) => setWho5Activo(e.target.value)}
                    />
                    3
                  </label>
                  <label className='radio' htmlFor='who5Activo-2'>
                    <input
                      id='who5Activo-2'
                      name='who5Activo'
                      type='radio'
                      value='2'
                      checked={who5Activo === "2"}
                      onChange={(e) => setWho5Activo(e.target.value)}
                    />
                    2
                  </label>
                  <label className='radio' htmlFor='who5Activo-1'>
                    <input
                      id='who5Activo-1'
                      name='who5Activo'
                      type='radio'
                      value='1'
                      checked={who5Activo === "1"}
                      onChange={(e) => setWho5Activo(e.target.value)}
                    />
                    1
                  </label>
                  <label className='radio' htmlFor='who5Activo-0'>
                    <input
                      id='who5Activo-0'
                      name='who5Activo'
                      type='radio'
                      value='0'
                      checked={who5Activo === "0"}
                      onChange={(e) => setWho5Activo(e.target.value)}
                    />
                    0
                  </label>
                </div>
              </div>
            </div>
            <div className='field'>
              <div className='control grid--2col'>
                <label className='radio-title' htmlFor='who5Despejado'>
                  4. me he despertado sintiéndome despejado y descansado
                </label>
                <div className='radio--6-col'>
                  <label className='radio' htmlFor='who5Despejado-5'>
                    <input
                      id='who5Despejado-5'
                      name='who5Despejado'
                      type='radio'
                      value='5'
                      checked={who5Despejado === "5"}
                      onChange={(e) => setWho5Despejado(e.target.value)}
                    />
                    5
                  </label>
                  <label className='radio' htmlFor='who5Despejado-4'>
                    <input
                      id='who5Despejado-4'
                      name='who5Despejado'
                      type='radio'
                      value='4'
                      checked={who5Despejado === "4"}
                      onChange={(e) => setWho5Despejado(e.target.value)}
                    />
                    4
                  </label>
                  <label className='radio' htmlFor='who5Despejado-3'>
                    <input
                      id='who5Despejado-3'
                      name='who5Despejado'
                      type='radio'
                      value='3'
                      checked={who5Despejado === "3"}
                      onChange={(e) => setWho5Despejado(e.target.value)}
                    />
                    3
                  </label>
                  <label className='radio' htmlFor='who5Despejado-2'>
                    <input
                      id='who5Despejado-2'
                      name='who5Despejado'
                      type='radio'
                      value='2'
                      checked={who5Despejado === "2"}
                      onChange={(e) => setWho5Despejado(e.target.value)}
                    />
                    2
                  </label>
                  <label className='radio' htmlFor='who5Despejado-1'>
                    <input
                      id='who5Despejado-1'
                      name='who5Despejado'
                      type='radio'
                      value='1'
                      checked={who5Despejado === "1"}
                      onChange={(e) => setWho5Despejado(e.target.value)}
                    />
                    1
                  </label>
                  <label className='radio' htmlFor='who5Despejado-0'>
                    <input
                      id='who5Despejado-0'
                      name='who5Despejado'
                      type='radio'
                      value='0'
                      checked={who5Despejado === "0"}
                      onChange={(e) => setWho5Despejado(e.target.value)}
                    />
                    0
                  </label>
                </div>
              </div>
            </div>
            <div className='field'>
              <div className='control grid--2col'>
                <label className='radio-title' htmlFor='who5Interesan'>
                  5. mi vida diaria se ha llenado de cosas que me interesan
                </label>
                <div className='radio--6-col'>
                  <label className='radio' htmlFor='who5Interesan-5'>
                    <input
                      id='who5Interesan-5'
                      name='who5Interesan'
                      type='radio'
                      value='5'
                      checked={who5Interesan === "5"}
                      onChange={(e) => setWho5Interesan(e.target.value)}
                    />
                    5
                  </label>
                  <label className='radio' htmlFor='who5Interesan-4'>
                    <input
                      id='who5Interesan-4'
                      name='who5Interesan'
                      type='radio'
                      value='4'
                      checked={who5Interesan === "4"}
                      onChange={(e) => setWho5Interesan(e.target.value)}
                    />
                    4
                  </label>
                  <label className='radio' htmlFor='who5Interesan-3'>
                    <input
                      id='who5Interesan-3'
                      name='who5Interesan'
                      type='radio'
                      value='3'
                      checked={who5Interesan === "3"}
                      onChange={(e) => setWho5Interesan(e.target.value)}
                    />
                    3
                  </label>
                  <label className='radio' htmlFor='who5Interesan-2'>
                    <input
                      id='who5Interesan-2'
                      name='who5Interesan'
                      type='radio'
                      value='2'
                      checked={who5Interesan === "2"}
                      onChange={(e) => setWho5Interesan(e.target.value)}
                    />
                    2
                  </label>
                  <label className='radio' htmlFor='who5Interesan-1'>
                    <input
                      id='who5Interesan-1'
                      name='who5Interesan'
                      type='radio'
                      value='1'
                      checked={who5Interesan === "1"}
                      onChange={(e) => setWho5Interesan(e.target.value)}
                    />
                    1
                  </label>
                  <label className='radio' htmlFor='who5Interesan-0'>
                    <input
                      id='who5Interesan-0'
                      name='who5Interesan'
                      type='radio'
                      value='0'
                      checked={who5Interesan === "0"}
                      onChange={(e) => setWho5Interesan(e.target.value)}
                    />
                    0
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className='form-results form-results-new form-results-audit'>
            <h3>Resultados de la autoevaluación WHO 5</h3>
            <p>Recuento total de puntos: {totalSumWho5}</p>
          </div>
        </form>
      </div>
      <div id='actions'>
        <button 
        className='button is-link' 
        form='formNewElement' 
        type='submit'
        disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
        </button>
      </div>
    </>
  );
}
